import React from "react";
import { Row, Col } from 'react-bootstrap';
import "./footer.css";

// app component
 class Footer extends React.Component {
  // render
  render() {
    return (
      <div className="footer-default">
        <Row>
          <Col className="text-center">
            <p>Copyright © Crowtech 2017</p>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/ui/components/Footer.js